import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, empty, Subject, of } from 'rxjs';
import { catchError, tap, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService, private _notification: MatSnackBar) { }

    refreshingAccessToken: boolean;

    accessTokenRefreshed: Subject<any> = new Subject();


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {

        if (request.headers.has('X-Skip-Interceptor')) {
            const headers = request.headers.delete('X-Skip-Interceptor');
            return next.handle(request.clone({ headers }));
        }

        request = this.addAuthHeader(request);

        return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {

            if (error.status === 401 && ! this.refreshingAccessToken) {
                return this.refreshAccessToken()
                    .pipe(
                        switchMap(() => {
                            request = this.addAuthHeader(request);
                            return next.handle(request);
                        }),
                        catchError((err: any) => {
                            this.authService.clearStorage();
                            this.openNotification('Session has expired!')
                            return empty();
                        })
                    )
            }else if(error.status == 403) {
                this.openNotification('Session has expired!')
                this.authService.clearStorage();
                return empty();
            }

            return throwError(error);
        })
        )
    }

    openNotification(msg){
        this._notification.open(msg, 'Cancel', {
          duration: 2000,
          horizontalPosition: 'right'
        })
      }



    refreshAccessToken() {
        if (this.refreshingAccessToken) {
            return new Observable(observer => {
                this.accessTokenRefreshed.subscribe(() => {
                    observer.next();
                    observer.complete();
                })
            })
        } else {
            this.refreshingAccessToken = true;
            return this.authService.refreshTokens().pipe(
                tap(() => {
                this.refreshingAccessToken = false;
                this.accessTokenRefreshed.next();
                })
            )
        }
        
    }


    addAuthHeader(request: HttpRequest<any>) {
        const token = this.authService.accessToken;
        
        if(token){
            return request.clone({
                setHeaders: {
                'Authorization': 'Bearer ' + token
                }
            })
        }
        
        return request
    }

}